// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"893c90b2","703":"d137a7de","787":"9622ca37"}[chunkId] + ".chunk.js";
};